import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import Global from '../../../../../store/global-selectors';
import { ltlShipmentsGridMessages } from '../messages';

const Destination = ({ freightShipmentId }: { freightShipmentId: string }) => {
  const shipment = useSelector((state) => Global.selectEntitiesFreightShipmentById(state, { freightShipmentId }));

  if (!shipment?.destinationAddress?.city && !shipment?.destinationAddress?.state) {
    return '';
  }

  return <>{[shipment.destinationAddress?.city, shipment.destinationAddress?.state].filter(Boolean).join(', ')}</>;
};

export const destination = {
  getMessageDescriptor: () => ltlShipmentsGridMessages.destination,
  name: <FormattedMessage {...ltlShipmentsGridMessages.destination} />,
  id: 'destination',
  width: 150,
  minWidth: 70,
  index: 4,
  render: (data: { id: string }) => <Destination freightShipmentId={data.id} />,
};
